import { Controller } from '@hotwired/stimulus';

//Don't touch it, because it will break
export default class extends Controller {
    connect() {
        this.currentTimeout = null;
        this.clubSelector = this.element.querySelector('#clubSelector');
        this.features = this.element.querySelector('.features');
        this.startingOffset = 15;
        this.slideWidth = screen.width - 165; //subtract every item's width apart from slide itself (gaps, labels, etc...)
        this.slideMaxWidth = this.features.scrollWidth - this.slideWidth;

        this.arrowPrev = this.element.querySelector('.navigation__prev');
        this.arrowNext = this.element.querySelector('.navigation__next');

        this.updateArrows();

        this.features.addEventListener('scroll', ()=>{
            this.updateArrows();
        })
    }

    scrollPrev() {
        let currentPos = this.features.scrollLeft;

        // No point in scrolling, already at the beginning
        if (currentPos <= this.startingOffset) {
            return;
        }

        clearTimeout(this.currentTimeout);
        this.features.scrollLeft -= this.slideWidth;
        this.updateArrows();
    }

    scrollNext() {
        let currentPos = this.slideWidth + this.features.scrollLeft;

        // No point in scrolling, already at the end
        if (currentPos >= this.slideMaxWidth) {
            return;
        }

        clearTimeout(this.currentTimeout);
        this.features.scrollLeft += this.slideWidth;
        this.updateArrows();
    }

    updateArrows() {
        this.currentTimeout = setTimeout(()=>{
            if (this.features.scrollLeft <= this.startingOffset) {
                this.arrowPrev.classList.add('disabled');
            } else {
                this.arrowPrev.classList.remove('disabled');
            }

            if ((this.slideWidth + this.features.scrollLeft) >= this.slideMaxWidth) {
                this.arrowNext.classList.add('disabled');
            } else {
                this.arrowNext.classList.remove('disabled');
            }
        }, 500) //Wait for smooth scroll to end, broken without it
    }

    toggleClubSelector(e) {
        if (e.currentTarget.checked) {
            this.clubSelector.parentNode.classList.add('d-none');
        } else {
            this.clubSelector.parentNode.classList.remove('d-none');
        }
    }
}
